import * as mapboxgl from 'mapbox-gl';
import { GeoJSONSource } from 'mapbox-gl';
import Mapbox from 'index.vue';
import { BaseFeatureLayer } from './baseFeatureLayer';
export class AreasLayer
{
    protected mapboxInstance: InstanceType<typeof Mapbox>;
    protected fillLayer: BaseFeatureLayer;
    


    constructor(mapboxInstance: InstanceType<typeof Mapbox>) {
        this.mapboxInstance = mapboxInstance;
        this.fillLayer = new BaseFeatureLayer(mapboxInstance, 'middle', 'areas-fill-layer', 'areas-fill-source', 'fill', {},{
            'fill-color': [
                'interpolate',
                ['linear'],
                ['coalesce', ['to-number', ['get', 'density']], 0],  // ← add 'to-number'
                0, 'rgba(232, 255, 232, 1)',
                128, 'rgba(76, 175, 64, 1)',
                255, 'rgba(38, 105, 32, 1)'
            ],
            'fill-opacity': 0.7
        }, true,true);
       
    }

    private getRow(fieldName: any, value: any, colorResult: boolean = false, postFix: string = '') {
        let value2 = value;
        if (colorResult && value > 0) value2 = '<span class="positiveResult">+' + value + postFix + '</span>';
        if (colorResult && value < 0) value2 = '<span class="negativeResult">' + value + postFix + '</span>';



        return '<div class="tbdc-row"><div>' + fieldName + '</div><div style="text-align: right; margin-left: 1em;">' + value2 + '</div><div></div></div>';

    }

    public DataChanged = async () => {
        if (this.mapboxInstance.areas != null) {
            this.mapboxInstance.areas.forEach((area: any) => {
                area.properties['outline-color'] = 'rgba(38, 105, 32, 1)';
                let titleHtml = '<h3>Area ' + area.properties.Code + '</h3><div class="tbdc-grid">';
                for (const key in area.properties) {
                    if (Object.prototype.hasOwnProperty.call(area.properties, key)) {
                        let value = area.properties[key as keyof typeof area.properties];
                        if (value === 'y') {
                            value = this.mapboxInstance.$t("message.yes");
                        } else if (value === 'n') {
                            value = this.mapboxInstance.$t("message.no");
                        }
                        if (key != 'density' && key != 'Code' && key != 'outline-color' && key != '' && key != null) titleHtml += this.getRow(key, value, false, '');
                    }
                }
                area.properties['titleHtml'] = titleHtml + '</div>';
            });
        }


        this.fillLayer.SetFeatures(this.mapboxInstance.areas == null ? [] : this.mapboxInstance.areas);
        
    };
}   
